import { MarketingPlataformaService } from "../../../shared/generated/grpc/plataforma_marketing_pb";
import { ServiceDeleteBase } from "../../../shared/services/base/ServiceDeleteBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { CampanaService } from "./CampanaService";

/** Baja de campaña; la saca de la lista en memoria (`remove` de la base). */
export class CampanaDeleteService extends ServiceDeleteBase {
  protected readonly cache = CampanaService.instance;

  /** gRPC-Web (`Eliminar`): baja lógica, idempotente. */
  protected async sendDelete(id: string): Promise<void> {
    await grpcCall(() => grpcClient(MarketingPlataformaService).eliminar({ id }));
  }
}
